import { API_URL } from '../../../app-config/constants';
import type SparkMetaDto from '../../../types/SparkMetaDto';
import type { SparkVisibility } from '../../react/components/Spark/content';
import { get, post } from '../request';

const RESOURCE = `${API_URL}/sparks`;

getOne.operation = 'READ';
export function getOne(storyId: string, typeId: string, visibility: SparkVisibility) {
    return get<SparkMetaDto>(`${RESOURCE}/${storyId}/${typeId}/${visibility}`);
}

visit.operation = 'COMMAND';
export function visit({ story, type, visibility }: { story: string; type: string; visibility: SparkVisibility }) {
    const params = {
        getData: { visibility },
    };
    return post<SparkMetaDto>(`${RESOURCE}/visit/${story}/${type}`, params);
}

dismiss.operation = 'COMMAND';
export function dismiss({ story, type }: { story: string; type: string }) {
    return post<SparkMetaDto>(`${RESOURCE}/dismiss/${story}/${type}`, {});
}
